import React from 'react';
import PropTypes from 'prop-types'

import Checkbox from 'material-ui/Checkbox';
import {ListItem} from 'material-ui/List';
import Toggle from 'material-ui/Toggle';
import Business from 'material-ui/svg-icons/communication/business';

import sum from 'lodash/sum';
import valuesIn from 'lodash/valuesIn';
import startCase from 'lodash/startCase';
import numeral from 'numeral';

import DatasetPromise from '../../util/datasetPromise';

const _ = {sum, valuesIn, startCase};

function objectSize (obj) {
  var count = 0;
  const keys = Object.keys(obj);

  for (var i = 0; i < keys.length; i ++){
    var c = keys[i];
    count += Object.keys(obj[c]).length;
  }

  return count;
}

function perThousandDots(num) {
  // return  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return numeral(num).format('(0,0)');
}

function sortProperties(obj) {
  return Object.keys(obj).sort(function(a,b){return obj[b]-obj[a]});
}

function convertKeys(str) {
  return Buffer.from(str, 'hex').toString('utf8')
}

class AmazingList extends React.Component {
  static propTypes = {
    onUpdate: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    // needs:
    // - poiList
    this.state = {
      poiListLoaded: false,
      poiList: {},
      selectedCategories: [],
      toggleCategories: false,
      selectedPois : {},
      toggleStatus: {},
      selectedSum: 0,
    };
  }

  componentDidMount() {
    this.fetchPoiData();
  }

  /**
   * Get settings from firebase.
   */
  fetchPoiData() {
    // DatasetPromise.getRegions().then(this.getRegionList);
    if(!this.state.poiListLoaded) {
      this.setState({poiListLoaded: true});
      DatasetPromise.getPois().then(this.getPoiList);
    }
  }

  /**
   * Poi selection from below
   */
  getPoiList = (obj) => { 
    let poiList = {};
    let selectedPois = {};
    let toggleStatus = {};
    const categories = Object.keys(obj);
    for (var i = 0; i < categories.length; i++){
      var c = categories[i];
      poiList[c] = obj[c];
      selectedPois[c] = [];
      toggleStatus[c] = false;
    }
    this.setState({
      poiList,
      selectedPois,
      toggleStatus,
    });
  }

  sumSelectedPois(selectedPois) {
    const poiList = this.state.poiList;
    let totalCategories = Object.keys(selectedPois);
    let sum = 0;
    for (let i = 0; i < totalCategories.length; i ++){
      let category = totalCategories[i];
      let currentSelectedShops = selectedPois[category];
      for (let j = 0; j < currentSelectedShops.length; j ++ ){
        let shop = currentSelectedShops[j];
        sum += poiList[category][shop];
      }
    };
    
    this.setState({selectedSum: sum});
    return sum;
  }

  onUpdate = (selectedPois) => {
    this.props.onUpdate(selectedPois, this.sumSelectedPois(selectedPois));
  }

  sumPois(category) {
    const numbers = _.valuesIn(this.state.poiList[category]);
    return _.sum(numbers);
  }
  /**
   * render Poi selection list outside render()
   */
  categoryList = () => {
    const categories = Object.keys(this.state.poiList);
    const categoryItems = categories.map((value, index) => (
      <ListItem
        key={index + 1}
        primaryText={_.startCase(value) + ' (' + perThousandDots(this.sumPois(value)) + ' POIs)'}
        initiallyOpen={false}
        leftCheckbox={<Checkbox 
          checked={this.getCategorySelectedState(value)}
          onCheck={this.onCategorySelectionChange(value)}
        />}
        nestedItems={ this.poiList(value) }
      />
    ));
    categoryItems.unshift(
      <ListItem
        key={0}
        primaryText={'Select all'}
        rightToggle={<Toggle 
          toggled={this.state.toggleCategories}
          onToggle={this.toggleCategorySelectAll}
        />}
      />
    );
    return categoryItems;
  }

  /**
   * @param {String} category 
   */
  poiList(category) {
    const poiObj = this.state.poiList[category];
    const poiKeys = sortProperties(poiObj);
    const poiItems = poiKeys.map((value, index) => (
      <ListItem
        key={index + 1}
        primaryText={convertKeys(value) + ' (' + perThousandDots(poiObj[value]) + ' POIs)'}
        leftCheckbox={<Checkbox 
          checked={this.state.selectedPois[category].indexOf(value) !== -1}
          onCheck={this.onShopSelectionChange(category, value)}
        />}
      />
    ));
    poiItems.unshift(
      <ListItem
        key={0}
        primaryText={'Select all'}
        rightToggle={<Toggle 
          toggled={this.state.toggleStatus[category]}
          onToggle={this.toggleShopSelectAll(category)}
        />}
      />
    );
    return poiItems;
  }

  
  // handlers for POI selection
  getCategorySelectedState = (value) => {
    const {selectedPois} = this.state;

    let categorySelected = this.state.selectedCategories.indexOf(value) !== -1;
    let shopsSelected = selectedPois[value].length > 0;

    return categorySelected && shopsSelected;
  }

  onShopSelectionChange = (category, poi) => (event, isInputChecked) => {
    let {selectedCategories, toggleCategories, selectedPois, toggleStatus} = this.state;
    const len = Object.keys(this.state.poiList[category]).length;
    const size = objectSize(this.state.poiList);

    selectedPois[category] = selectedPois[category].filter((value, index) => value === poi ? false : true);

    if (selectedPois[category].length === 0){
      var index = selectedCategories.indexOf(category);
      selectedCategories.slice(index, 1);
    }
  

    if (isInputChecked) {
      selectedPois[category].push(poi);
      selectedCategories.push(category);
    }

    toggleStatus[category] = len > selectedPois[category].length ? false : true;
    toggleCategories = size > objectSize(selectedPois) ? false : true;
  
    this.setState({
      selectedCategories,
      toggleCategories,
      selectedPois,
      toggleStatus,
    });

    this.onUpdate(selectedPois);

  }

  toggleShopSelectAll = (category) => (event) => {
    let {selectedCategories, toggleCategories, selectedPois, toggleStatus} = this.state;
    const allShopsPerCategory = Object.keys(this.state.poiList[category]);
    const allCategories = Object.keys(this.state.poiList);
    const removedCategories = allCategories.filter(e => e !== category);
    
    selectedPois[category] = toggleStatus[category] ? [] : allShopsPerCategory;
    selectedCategories = toggleStatus[category] ? removedCategories : allCategories;

    toggleStatus[category] = !toggleStatus[category];

    toggleCategories = toggleStatus[category];
    for (var i = 0; i < Object.keys(toggleStatus).length; i ++) {
      var c = Object.keys(toggleStatus)[i];
      toggleCategories = toggleCategories && toggleStatus[c];
    }

    this.setState({
      selectedCategories,
      toggleCategories,
      selectedPois,
      toggleStatus,
    });
  
    this.onUpdate(selectedPois);

  }

  onCategorySelectionChange = (category) => (event, isInputChecked) => {
    let {selectedCategories, toggleCategories, selectedPois, toggleStatus} = this.state;
    const allCategories = Object.keys(this.state.poiList);
    const allShopsPerCategory = Object.keys(this.state.poiList[category]);

    //selectedCategories = selectedCategories.filter((value, index) => value === category ? false : true);
    let selection = [];
    selectedCategories.map((value, index) => {
      if (value !== category) {
        selection.push(value);
      } else {
        selectedPois[category] = [];
      }
      selectedCategories = selection;
      return {selectedCategories, selectedPois};
    })
    

    if (isInputChecked) {
      selectedCategories.push(category);
      selectedPois[category] = allShopsPerCategory;
    }

    toggleCategories = allCategories.length > selectedCategories.length ? false : true;
    toggleStatus[category] = allShopsPerCategory.length > selectedPois[category].length ? false : true;

    this.setState({
      selectedCategories,
      toggleCategories,
      selectedPois,
      toggleStatus
    });

    this.onUpdate(selectedPois);
  }

  toggleCategorySelectAll = (event) => {
    let {selectedCategories, toggleCategories, selectedPois, toggleStatus} = this.state;
    const poiList = this.state.poiList;
    const categories = Object.keys(poiList);

    selectedCategories = toggleCategories ? [] : categories;
    for (var i = 0; i < categories.length; i++){
      var c = categories[i];
      selectedPois[c] = toggleCategories ? [] : Object.keys(poiList[c]);
      toggleStatus[c] = toggleCategories ? false : true;
    }

    toggleCategories = !toggleCategories;

    this.setState({
      toggleCategories,
      selectedCategories,
      selectedPois,
      toggleStatus,
    });

    this.onUpdate(selectedPois);
  }

  render() {
    const readyToRenderPoiList = Object.keys(this.state.poiList).length > 0;
    return (
      readyToRenderPoiList &&
        <ListItem
          leftIcon={<Business />}
          primaryText="POIs"
          initiallyOpen={true}
          primaryTogglesNestedList={true}
          nestedItems={this.categoryList()}
        />
    );
  }

}

export default AmazingList



// WEBPACK FOOTER //
// ./src/components/PoiStepSourceForm/AmazingList.jsx